import React, { Component } from 'react';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import Script from 'react-load-script'
import {Redirect, Link} from 'react-router-dom';
import './Checkout.scss';
import { ToastContainer, toast } from 'react-toastify';
import visamastercard from './../../../images/visa-mastercard.png';
// const stripe = window.Stripe('pk_test_GL8E6YqBKCvoAvngU1AsNdCF00R7vita6H');

class Checkout extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loggedIn: false,
         loading:true,
         loaderButton : false,
         orderId: [],
         paid: null,
         scriptLoaded : null,
         scriptError : null
      };
   }
   handleScriptCreate() {
      this.setState({ scriptLoaded: false })
   }
   handleScriptError() {
      this.setState({ scriptError: true })
   }  
   handleScriptLoad() {
      this.setState({ scriptLoaded: true })
   }
   makePayment = async (e) => {
      e.preventDefault();
      this.setState({loaderButton:true})
      axios({
         method: 'GET',
         url: '/order/detail/' + this.props.match.params.orderId,
      }).then(
         (response) => {
            console.log('response data chekoutOrder ', response.data);
            if(response.data.status === true){
               if(response.data.data.paymentType === 1){
                  // if(response.data.data.stripeSessionId){
                  //    // redirect to stripe
                  //    console.log('redirect to stripe');
                  //    setTimeout(
                  //       function(){
                  //          stripe.redirectToCheckout({
                  //             sessionId: response.data.data.stripeSessionId
                  //          }).then((result) => {
                  //             toast.error("Error! " + result)
                  //          });
                  //       }
                  //    , 2500)
                  // }
               } else if (response.data.data.paymentType === 2){
                  if(response.data.data.midtransSnapToken){
                     setTimeout(
                        function(){
                           window.snap.pay(response.data.data.midtransSnapToken, {
                              // Optional
                              onSuccess: function(result){
                                 /* You may add your own js here, this is just example */ 
                                 console.log('customer onSuccess ', result);
                                 if(result.status_code === '200'){
                                    toast.success("Success! Payment has competed")
                                    setTimeout(
                                       function(){
                                          window.location.href = '/transaction/'+ result.order_id
                                       }, 2500
                                    )
                                 }
                              },
                              // Optional
                              onPending: function(result){
                                 /* You may add your own js here, this is just example */
                                 console.log('customer onPending ', result);
                                 toast.error("Your payment has been pending")
                                 setTimeout(
                                    function(){
                                       window.location.href = '/checkout/'+ response.data.data.orderId + '/thanks';
                                    }, 2500
                                 )
                              },
                              // Optional
                              onError: function(result){
                                 /* You may add your own js here, this is just example */ 
                                 console.log('customer onError ', result);
                                 toast.error("Error, Your payment has not been completed")
                                 setTimeout(
                                    function(){
                                       window.location.href = '/checkout/'+ response.data.data.orderId + '/thanks';
                                    }, 2500
                                 )
                              },
                              onClose: function(result){
                                 console.log('customer closed the popup without finishing the payment', result);
                                 toast.error("Your payment has not been completed")
                                 setTimeout(
                                    function(){
                                       window.location.href = '/checkout/'+ response.data.data.orderId + '/thanks';
                                    }, 2500
                                 )
                              }
                           });
                        }
                     , 2500)
                  }
               }
            } else {
               toast.error("Error! "+  response.data.error);
            }
         }
      );
   }

   componentDidMount() {
      const userData = localStorage.getItem("userData");
      if(userData){
         this.setState({loggedIn : true, companyName : JSON.parse(userData).data.companyName}) 
      }
      axios.get('/order/detail/'+this.props.match.params.orderId)
      .then(res => {
         console.log('res order detail ', res.data)
         if(res.data.status === true){
            this.setState({ orderId: res.data.data, loading:false });
            if(res.data.data.paid === 1){
               this.setState({ paid: true });
            }
         } else {
            this.setState({ loading: true });
            toast.error("Error! " + res.data.error);
         }
         
         
      })
   }
   
   render() {
      if(!localStorage.getItem('userData')){
         return (<Redirect to={'/'}/>)
      } 
      if(this.state.paid === true){
         return (<Redirect to={'/transaction/'+ this.props.match.params.orderId}/>)
      } 
      return (
         <div id="checkoutpage" className="content-page checkout">
            <Script
            url="https://app.sandbox.midtrans.com/snap/snap.js"
            attributes={{ 'data-client-key': 'SB-Mid-client-w1paPKwLDmcqbvmS'}}
            onCreate={this.handleScriptCreate.bind(this)}
            onError={this.handleScriptError.bind(this)}
            onLoad={this.handleScriptLoad.bind(this)}
            />
            <ToastContainer />
            <div className="container">
               <div className="row">
                  <div className="col align-self-center">
                  {
                     this.state.loading === true ? ('') : (
                        <div className="card shadow" style={{width:'500px', margin: 'auto'}}>
                           <div className="card-body text-center">
                              <h2 className="text-green lh-26">
                                 Thanks for your order. 
                              </h2>
                              <h3 className="text-green lh-26">Finish your payment to complete the order.</h3>
                              <h3>
                                 Hi {this.state.orderId.companyName}
                              </h3>
                              {
                                 this.state.orderId.paymentType === 0 ? (
                                    <div>
                                       <p className="lh-22">
                                       We will send an email with all your order details. Please make payment no later than 14 days after you receive the email.
                                       </p>
                                       <h3 className="mb-2">
                                          INVOICE ID
                                       </h3>
                                       <h2 className="text-green">
                                          {this.state.orderId.invoiceId}
                                       </h2>
                                       <Link to={`/transaction/${this.state.orderId.orderId}`} className="btn btn-green btn-block text-center">
                                          VIEW TRANSACTION DETAIL
                                       </Link>
                                    </div>
                                 ) : (
                                    <div>
                                       <p className="lh-22">
                                       One step closer to complete your payment.
                                       </p>
                                       <h3 className="mb-2">
                                          GRAND TOTAL
                                       </h3>
                                       <h2 className="text-orange">
                                       {this.state.orderId.orderDetails[0].currencySymbol} 
                                       &nbsp;<NumberFormat value={this.state.orderId.grandTotal} displayType={'text'} thousandSeparator={true} decimalScale={0}/>
                                       </h2>
                                       <h3 className="mb-2">
                                          INVOICE ID
                                       </h3>
                                       <h2 className="text-green">
                                          {this.state.orderId.invoiceId}
                                       </h2>
                                       <button className="btn btn-orange btn-block mb-3" onClick={this.makePayment}>
                                       {this.state.loaderButton === true ? (
                                          <span><i className="fa fa-spin fa-spinner"></i> Waiting..</span>
                                       ) : ('PAY NOW')} 
                                       </button>
                                       {
                                       this.state.orderId.paymentType === 1 ? (
                                          <div>
                                             <img src={visamastercard} alt="Visa or Mastercard"  style={{width:'auto', height:'20px', margin: 'auto'}}/>
                                          </div>
                                          ) : (
                                             <div className="text-center">
                                                <span>Credit Card, Bank Transfer (VA), GoPay</span>
                                             </div>
                                          ) 
                                       }
                                       
                                    </div>
                                 )
                              }
                           </div>
                        </div>
                     )
                  }
                  </div>
               </div>
            </div>
         </div>
         )
      }
   }

   export default Checkout;